import { isAiSubmittable } from "@memorang/helpers/session";
import type {
	Choice,
	ItemFeedback,
	ItemResponse,
	OriginalItemTypes,
	ToeicArtifactType,
} from "@memorang/types";
import type { FontSchemaType } from "../../font";
import DynamicExplanation from "./DynamicExplanation";
import StaticExplanation from "./StaticExplanation";

type Props = {
	responseType: ItemResponse["type"];
	itemType?: OriginalItemTypes;
	toeicArtifactType?: ToeicArtifactType;
	choices: Choice[];
	persistedAiFeedback?: string;
	currentAiFeedback?: string;
	emptyFeedbackText?: string;
	appFont: FontSchemaType;
	explanationTitle: string;
	renderTtsContainer?: (explanation?: string) => React.ReactNode;
	renderFeedbackMenu?: () => React.ReactNode;
	itemFeedback?: ItemFeedback;
	fontSize: number;
	language: string;
	streaming?: boolean;
	forceDynamic?: boolean;
};
const ExplanationContainer = ({
	responseType,
	itemType,
	toeicArtifactType,
	choices,
	persistedAiFeedback,
	currentAiFeedback,
	emptyFeedbackText,
	appFont,
	explanationTitle,
	renderTtsContainer,
	renderFeedbackMenu,
	itemFeedback,
	fontSize,
	language,
	streaming,
	forceDynamic,
}: Props) => {
	const isAiItemType = isAiSubmittable(
		responseType,
		itemType,
		toeicArtifactType,
		Boolean(itemFeedback?.length),
	);

	if (isAiItemType || forceDynamic) {
		return (
			<DynamicExplanation
				aiResponse={currentAiFeedback}
				loading={streaming}
				renderTtsContainer={renderTtsContainer}
				renderFeedbackMenu={renderFeedbackMenu}
				explanationTitle={explanationTitle}
				appFont={appFont}
				fontSize={fontSize}
				persistedAiFeedback={persistedAiFeedback}
				currentAiFeedback={currentAiFeedback}
				emptyFeedbackText={emptyFeedbackText}
			/>
		);
	}

	return (
		<StaticExplanation
			choices={choices}
			itemFeedback={itemFeedback}
			appFont={appFont}
			fontSize={fontSize}
			renderTtsContainer={renderTtsContainer}
			language={language}
			explanationTitle={explanationTitle}
		/>
	);
};

export default ExplanationContainer;
